export const GLOBAL_BUSINESS_VARIABLES = {
  totalStockAvailable: {
    defaultValue: '11',
    stringValueWithM: '11M',
    numberValue: 11,
    numberValueExtended: '11.000.000',
  },
};
